import * as React from "react";
import uuid from "react-native-uuid";
import {
  Modal,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
  Text,
  ScrollView,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { launchCamera } from "@utils/imagePickerCompat";
import CloseIcon from "@assets/svg/CloseIcon";
import { uploadImage } from "@services/api";
import colors from "@constants/color";
import checkPermissions from "./checkPermissions";
import ModalHeader from "../../ModalHeader";
import ModalBottomButton from "../../ModalBottomButton";

const { width } = Dimensions.get("window");

const ImageBlock = ({ url, onPress, remove, src }) => {
  return (
    <View
      style={{
        width: 0.44 * width,
        height: 0.44 * width,
        marginBottom: 0.04 * width,
        borderColor: "#e6e6e6",
        borderWidth: 1,
        borderStyle: "dotted",
      }}
    >
      {url || src ? (
        <View>
          <Image
            style={{ height: "100%", width: "100%" }}
            resizeMode="contain"
            source={url ? { uri: url } : src}
          />
          <View
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              backgroundColor: "#ffffff66",
              borderRadius: 15,
              borderColor: "#e6e6e6",
              borderWidth: 1,
              width: 30,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TouchableOpacity onPress={remove}>
              <CloseIcon />
            </TouchableOpacity>
          </View>
          {src && !url && (
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.1)",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ActivityIndicator size="large" color={colors.primary} />
            </View>
          )}
        </View>
      ) : (
        <TouchableOpacity onPress={onPress}>
          <View
            style={{
              height: "100%",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              borderStyle: "dashed",
              borderColor: "#e6e6e6",
              borderWidth: StyleSheet.hairlineWidth,
              borderRadius: 1,
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: 14 }}>+</Text>
            <Text style={{ fontWeight: "600", fontSize: 14 }}>फोटो डालें</Text>
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
};

const onClickImageBlock = async (idx, updateUrlRef, updateSrc) => {
  try {
    await checkPermissions();
    // Camera-only (no gallery) per app-wide policy.
    launchCamera(
      {
        mediaType: "photo",
        maxHeight: 500,
        maxWidth: 700,
        quality: 0.4,
      },
      (response) => onImageSelect(response),
    );

    const onImageSelect = async (response) => {
      try {
        if (response.didCancel) {
          return;
        } else if (response.error) {
          console.log("ImagePicker Error: ", response.error);
        }
        const source = { uri: `data:image/jpeg;base64,${response.data}` };
        const id = String(uuid.v1());
        updateSrc({ source, id });
        const data = new FormData();
        data.append("image", {
          uri: response.uri,
          type: response.type,
          name: response.fileName,
        });
        const { data: uploadData } = await uploadImage(data);
        updateUrlRef.current(id, uploadData.url);
      } catch (e) {
        console.log(e);
      }
    };
  } catch (e) {
    console.log(e);
  }
};

const ImagesModal = ({
  visible,
  onRequestClose,
  srcMap,
  remove,
  updateSrc,
  updateUrlRef,
}) => {
  const insets = useSafeAreaInsets();
  return (
    <Modal
      visible={visible}
      onRequestClose={onRequestClose}
      statusBarTranslucent
      navigationBarTranslucent
    >
      <View
        style={{
          flex: 1,
          paddingTop: insets.top,
          paddingBottom: insets.bottom,
        }}
      >
        <View style={{ marginBottom: 10 }}>
          <ModalHeader title="फोटो अपलोड करें" onClose={onRequestClose} />
        </View>
        <ScrollView>
          <View
            style={{
              height: "100%",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            {Array.from(new Array(4)).map((_, idx) => {
              return (
                <ImageBlock
                  key={idx}
                  onPress={() => {
                    onClickImageBlock(idx, updateUrlRef, updateSrc);
                  }}
                  url={srcMap[idx] && srcMap[idx].url}
                  remove={() => remove(srcMap[idx] && srcMap[idx].id)}
                  src={srcMap[idx] && srcMap[idx].source}
                />
              );
            })}
          </View>
        </ScrollView>
        <ModalBottomButton onSubmit={onRequestClose} />
      </View>
    </Modal>
  );
};

export default ImagesModal;
